export enum ValueTypeEnum {
  Amount = 'amount',
  Percentage = 'percentage',
}